import { getAxiosConfigUserToken } from 'app/utils/appHelpers';
import axios from 'axios';
import config from '../../config';

export const getObjectListApi = async (objectName) => {
   const url = `${config.apiUrl}/v1/${objectName}/`;
   return await axios.get(url, getAxiosConfigUserToken()).then(response => response.data
   )
}
export const getObjectByIdApi = async (objectName, id) => {
   const url = `${config.apiUrl}/v1/${objectName}/${id}`;
   return await axios.get(url, getAxiosConfigUserToken())
      .then(response => response.data)
}
export const getObjectByPropertyApi = async (objectName, propertyName, propertyValue) => {
   const url = `${config.apiUrl}/v1/${objectName}/${propertyName}/${propertyValue}`;
   return await axios.get(url, getAxiosConfigUserToken())
      .then(response => response.data)
}


export const getObjectListByPropertyApi = async (objectName, propertyName, propertyValue) => {
   const url = `${config.apiUrl}/v1/${objectName}/list/${propertyName}/${propertyValue}`;
   return await axios.get(url, getAxiosConfigUserToken())
      .then(response => response.data)
}
export const postObjectListByPropertyListApi = async (objectName, propertyObject) => {
   const url = `${config.apiUrl}/v1/${objectName}/list/`;
   return await axios.post(url, propertyObject, getAxiosConfigUserToken())
      .then(response => response.data)
}
export const postSaveObjectApi = async (objectName, object) => {

   const url = `${config.apiUrl}/v1/${objectName}/`;
   return await axios.post(url, object, getAxiosConfigUserToken())
      .then(response => response.data);
}
// export const postSaveCronObjectApi = async (object) => {

//    const url = `${config.apiUrl}/v1/saveCronData/`;
//    return await axios.post(url, object, getAxiosConfigUserToken())
//       .then(response => response.data);
// }
export const putUpdateObjectApi = async (objectName, object) => {

   const url = `${config.apiUrl}/v1/${objectName}/`;
   return await axios.put(url, object, getAxiosConfigUserToken())
      .then(response => response.data);
}
export const putUpdateObjectByPropertyApi = async (objectName, object, propertyName) => {
   const url = `${config.apiUrl}/v1/${objectName}/${propertyName}/`;

   return await axios.put(url, object, getAxiosConfigUserToken())
      .then(response => response.data);
}
export const putUpdateObjectByIdListApi = async (objectName, object, idList) => {
   const url = `${config.apiUrl}/v1/${objectName}/list/${idList.join(",")}`;
   return await axios.put(url, object, getAxiosConfigUserToken())
      .then(response => response.data);
}
export const deleteObjectApi = async (objectName, id) => {
   const url = `${config.apiUrl}/v1/${objectName}/${id}`;
   return await axios.delete(url, getAxiosConfigUserToken())
      .then(response => response.data);
}
export const getObjectPropertyListByPropertyApi = async (objectName, propertyList, propertyName, propertyValue) => {
   const url = `${config.apiUrl}/v1/${objectName}/listByProperty/${propertyList}/${propertyName}/${propertyValue}`;
   return await axios.get(url, getAxiosConfigUserToken())
      .then(response => response.data)
}
export const getObjectPropertyListByPropertyArrayApi = async (objectName, propertyList, propertyName, propertyValueList) => {

   const url = `${config.apiUrl}/v1/${objectName}/listByPropertyArray/${propertyList}/${propertyName}/${propertyValueList}`;
   return await axios.get(url, getAxiosConfigUserToken())
      .then(response => response.data)
}
export const putUpdateObjectByPropertyV2Api = async (objectName, object, propertyName) => {
   const url = `${config.apiUrl}/v1/${objectName}/byProperty/${propertyName}/`;
   return await axios.put(url, object, getAxiosConfigUserToken())
      .then(response => response.data);
}
export const deleteObjectByPropertyApi = async (objectName, propertyName, propertyValue) => {
   const url = `${config.apiUrl}/v1/${objectName}/${propertyName}/${propertyValue}`;
   return await axios.delete(url, getAxiosConfigUserToken())
      .then(response => response.data)
}
export const getObjectPropertyListApi = async (objectName, byPropertyList) => {
   const url = `${config.apiUrl}/v1/${objectName}/byProperty/${byPropertyList}`;
   //:objectName/byProperty/:byPropertyList
   return await axios.get(url, getAxiosConfigUserToken())
      .then(response => response.data)
}

// export const getFindSameRecord = async (objectName, propertyName, propertyValue) => {
//    const url = `${config.apiUrl}/v1/${objectName}/${propertyName}/${propertyValue}`;
//    return await axios.get(url, getAxiosConfigUserToken())
//       .then(response => response.data)
// }

export const getObjectListByPropertyValueArrayApi = async (objectName, propertyName, byPropertyValueArray) => {
   const url = `${config.apiUrl}/v1/${objectName}/listByPropertyValueArray/${propertyName}/${byPropertyValueArray}`;
   return await axios.get(url, getAxiosConfigUserToken())
      .then(response => response.data)
}

// yeni eklenenler
export const putUpdateObjectListByPropertyValueArrayApi = async (objectName, propertyName, objectList) => {
   const url = `${config.apiUrl}/v1/${objectName}/upd/${propertyName}`;

   return await axios
      .put(url, objectList, getAxiosConfigUserToken())
      .then(response => response.data);
};





